import { classes } from 'html-classes';

import { IconTypes } from '~/components/Icon/IconTypes';
import { IconButton } from '~/components/isolated/IconButton';

import styles from './ModalHeader.module.scss';

interface ModalHeaderProps {
  title: string;
  onClose?: () => void;
  onClick?: () => void;
  variant?: 'default' | 'dark';
  size?: 'S' | 'L';
  icon?: IconTypes;
  className?: string;
}

export const ModalHeader = ({
  title,
  onClose,
  onClick,
  variant = 'default',
  size,
  icon = 'close',
  className,
}: ModalHeaderProps) => {
  return (
    <div
      className={classes([
        styles.header,
        variant === 'dark' && styles.dark,
        size === 'S' && styles.sizeS,
        className,
      ])}
    >
      <span className={styles.title}>{title}</span>
      {(onClose || onClick) && (
        <IconButton
          variant="outline"
          size="S"
          icon={icon}
          onClick={onClose || onClick}
        />
      )}
    </div>
  );
};
